/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 17:24:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 17:57:00
 * @FilePath: /unifyxp-v2-store-portal/src/tools/selectors/search.ts
 */
import { createSelector } from '@reduxjs/toolkit';
import { getStateTarget as getTarget } from 'src/tools/helper';

const getSearchCondition = (reducer) => {
  return createSelector(
    (state: any) => getTarget(state, reducer).searchConditions,
    (conditions) => {
      return conditions;
    },
  );
};

export { getSearchCondition };
